import { useTransactionsFeesPartyID } from "Api/Queries/Transactions/useTransactionsFeesPartyID";
import { BaseTransactionFeesTab } from "Components/Transactions/UserTransactionFees/BaseTransactionFeesTab";
import { useLoggedInUser } from "Hooks/useLoggedInUser";
import { getRegionCurrency } from "Utils/CurrencyUtils";
import { endOfMonth, startOfMonth } from "date-fns";
import { Resources, useResource } from "Translations/Resources";

const COMPONENT_RESOURCES =
  Resources.Components.Transactions.MerchantDetailTransactionFees;

type Props = {
  partyPublicID: string;
};

export const MerchantDetailTransactionFees = ({ partyPublicID }: Props) => {
  const { t } = useResource();
  const dateFrom = startOfMonth(new Date()).toISOString();
  const dateTo = endOfMonth(new Date()).toISOString();
  const currentUser = useLoggedInUser();

  const { data: fees, isLoading } = useTransactionsFeesPartyID(
    partyPublicID,
    dateFrom,
    dateTo,
  );

  return (
    <BaseTransactionFeesTab
      amounts={fees?.totalFees ?? []}
      emptyStateCurrency={
        currentUser?.region ? getRegionCurrency(currentUser.region) : undefined
      }
      isLoading={isLoading}
      title={t(COMPONENT_RESOURCES.Title)}
      colorVariant="warning"
    />
  );
};
